import angular from 'angular';

import PlanPriceComponent from './plan-price.cmpt';

export default angular
    .module('common.plans.component.plan-price', [])
    .component(PlanPriceComponent.selector, PlanPriceComponent);



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/component/plan-price/index.js